import styled from 'styled-components';
import {theme} from "../../../../styled/theme"

export const List = styled.ul`
  padding-left: 25px;
`;

export const ListItem = styled.li`
  font-size: 1rem;
  font-weight: 400;
  color: ${theme.palette.text.primary};
`;
